import { Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment as env } from '../../../../environments/environment'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'verification_code_whatsapp',
    templateUrl: './verification_code_whatsapp.component.html',
    styleUrls: ['./verification_code_whatsapp.component.scss'],
    providers: []
})
export class VerificatioCodeWhatsappComponent {

    private _basePathapi = env.url + env.api_cli;
    text_error: string = '';
    flag_error_code: boolean = false;
    flag_progress: boolean = false;
    flag_code_send : boolean = false;
    form_code_verification : FormGroup;
    form_phone : FormGroup;
    loading: boolean = false;

    constructor( public translate: TranslateService, private _formBuilder: FormBuilder,private _httpClient: HttpClient,
        @Inject(MAT_DIALOG_DATA) public datos: DialogData,public dialog: MatDialogRef<VerificatioCodeWhatsappComponent>) {


        this.form_code_verification = this._formBuilder.group({
            code: ['', [Validators.required]],
        });

        this.form_phone = this._formBuilder.group({
            phone: [datos.phone, [Validators.required, Validators.pattern("\\+?[-\\/0-9 ]{0,15}$")]],
        });
    }

    ngOnInit(){

    }

    send_code(){
        this.loading = true;
        let header_node = {
            headers: new HttpHeaders(
                {
                    'Accept': 'application/json','Authorization': 'Bearer ' + this.datos.token
                })
            };
        let params_whatsapp = {
            phone : this.form_phone.controls['phone'].value
        }
        this._httpClient.post(this._basePathapi + 'check_phone/', params_whatsapp, header_node).subscribe(()=>{
            this._httpClient.post(this._basePathapi + 'auth/registration/basic/?method=what', params_whatsapp, header_node).subscribe(()=>{
                this.flag_code_send = true;
                this.flag_error_code = false;
                this.loading = false;
            });
        }, (error)=>{
            this.loading = false;
            this.flag_error_code = true;
            this.text_error = error.error.errors[0]['text'];
        });

    }

    validate_code(){
        this.loading = true;
        let header_node = {
            headers: new HttpHeaders(
                {
                  'Accept': 'application/json',
                  'Authorization': 'Bearer ' + this.datos.token
              })
        };

        let params = {
            "code_verification" : this.form_code_verification.controls['code'].value,
            "phone" : this.form_phone.controls['phone'].value
        };

        return this._httpClient.post(this._basePathapi + 'validate/code/', params, header_node).subscribe(resp=>{
            this.flag_progress = true;
            this.flag_error_code = false;

        }, (error)=>{
            this.loading = false;
            this.flag_error_code = true;
            this.text_error = error.error.errors[0]['text'];
        });

    }

    closeDialog(event:boolean){
        this.dialog.close({event: event});
    }

}

export interface DialogData {
    phone : number;
    token:string;
}

